export default "__VITE_ASSET__CAfZFN3S__"